import React, { Component } from "react";
import classes from "./VendorpaymentAdvice.module.css";
import axios from "../../../../axios-order";
import ErrorIcon from "@material-ui/icons/Error";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "../../../../components/ui/Cards";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import DataTables from "material-ui-datatables";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import VendorPaymentAdvice from "../../../../asserts/templates/vendor_payment_advice.xlsx";
import SelectField from "../../../../components/ui/select";
import VisibilityIcon from "@material-ui/icons/Visibility";
import TextField from "@material-ui/core/TextField";
import NumberFormat from "react-number-format";
import Drawer from "@material-ui/core/Drawer";
import ClearIcon from "@material-ui/icons/Clear";
import TuneIcon from "@mui/icons-material/Tune";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../../../components/ui/inputField";
import CircularProgress from "@material-ui/core/CircularProgress";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import Modal from "react-bootstrap/Modal";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CustomTable from "../../../../components/ui/Table/Table";
import { toast } from "react-toastify";
import { TablePagination } from "@material-ui/core";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';
import moment from "moment";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Chip from "@material-ui/core/Chip";

import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RightDrawer from "../../../../components/ui/RightDrawer";
import ZohoModel from "../../../../components/ZohoModel/ZohoModel";
import ErpConnectorModel from "../../../../components/ZohoModel/ErpConnector";
import { canWrite } from "../../../../utils/privilegeUtils";
import { FormControl, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import DatePicker from '../../../../components/ui/DatePicker'

let flagForVendorPayment = 1;
let variableForTimer = null;

const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumSignificantDigits: 10,
  }).format(value);
// ---End---

const dateFormatWithDash = (value) => {
  if (value) {
    let old_date = String(value).split("-");
    return old_date[2] + "-" + old_date[1] + "-" + old_date[0];
  }
};

// Set to true AFTER BoxWrapper has been given a `headerExtra` prop (render
// {props.headerExtra} right after its search input). The Filter button then
// appears next to the Payment Advice search. While false, the button is
// rendered just above the table instead, so it never disappears.
const FILTER_BUTTON_IN_BOXWRAPPER = true;

class VendorpaymentAdvice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExportingAll: false,
      effitracCol: [
        {
          key: "Vendor Code+",
          render: (index, row) => {
            return row["erpVendorCode"];
          },
        },

        {
          key: "gstin",
          render: (index, row) => {
            return row["vendorGstin"];
          },
        },

        {
          key: "invoiceNo",
          render: (index, row) => {
            return row["invoiceNo"];
          },
        },
        {
          key: "invoiceDate",
          render: (index, row) => {
            return row["invoiceDate"]
            // ? dateFormatWithDash(row["invoiceDate"])
            // : "";
          },
        },

        {
          key: "paymentDate",
          render: (index, row) => {
            return row["paymentDate"]
            // ? dateFormatWithDash(row["paymentDate"])
            // : "";
          },
        },
        {
          key: "transactionRefNo",
          render: (index, row) => {
            return row["transactionRefNumber"];
          },
        },

        {
          key: "amountPaid",
          render: (index, row) => {
            return numberFormat(row["amountPaid"]);
          },
        },

        // {
        //   key: "tdsAmount",
        //   render: (index, row) => {
        //     return numberFormat(row["tdsAmount"]);
        //   },
        // },
        {
          key: "adjustmentMethod",
          render: (index, row) => {
            return row["adjustmentMethod"];
          },
        },
      ],
      effitracData: null,
      oldEffitracData: null,
      effitracHeader: [
        { label: "ERP Vendor Code" },
        { label: "GSTIN" },
        { label: "Bill Number" },
        { label: "Bill Date" },
        { label: "Payment Date" },
        { label: "Transaction Ref No" },
        { label: "Amount Paid" },
        // { label: "TDS Amount" },
        { label: "Adjustment Method" },
      ],
      paymentDateDisplay: "",
      invoiceDateDisplay: "",
      read_only: "",
      next: {},
      prev: {},
      file_value: null,
      total_records: 0,
      errorPage: 1, // Current page
      perErrorPages: 10, // Records per page
      errortotal: 0, // Total records 
      successful_records: 0,
      error_records: 0,
      error_rows: {},
      loadingExport:false,
      sellerCustomerCol: [
        // { key: 'seller_code', label: 'Seller Code', },
        {
          label: "GSTIN",
          render: (name, all) => {
            return all["record"]["vendorGstin"];
          },
        },
        {
          label: "Invoice Number",
          render: (name, all) => {
            return all["record"]["invoiceNumber"];
          },
        },
        { key: "row", label: "Row #" },
        {
          label: "Errors",
          render: (name, all) => {
            return Object.keys(all["errors_in"]).map((i, v) => {
              return (
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <span>{i}</span>&nbsp;<span>:</span>&nbsp;
                  <span style={{ color: "red" }}>
                    {all["errors_in"][i].join(",")}
                  </span>
                </div>
              );
            });
          },
        },
        // {label:"Status",key:"status"}
      ],
      sellerCustomerData: [],
      error: null,
      allArcPaymentAdviceData: [],
      OriginalAllArcPaymentAdviceData: [],
      showUploadData: false,
      showDrawer: false,
      showPaymentDetailsData: {},
      loading: false,
      invicedateForAddDisplay: "",
      add_DrawerOpen: false,
      addPaymentAdviceData: {
        vendorGstin: "",
        invoiceNumber: "",
        invoiceDate: "",
        amountPaid: null,
        paymentDate: "",
        transactionRefNumber: "",
        tdsAmount: null,
        bankAccountNumber: "",
        typeOfTransactions: "",
        erpVendorCode: "",
      },

      autoSync: false,

      edit_DrawerOpen: false,
      editPaymentAdviceData: {},

      //..............Edited by Harsh............
      openZohoDrawer: false,
      messageForConnection: "Establish Connection",
      buttonColor: "red",
      grantToken: "",
      url: "",
      zohoDate: {},

      // add paymentAdvice modal
      invoiceApiDataForPaymentAdviceModal: [],
      invoiceApiSearchDataForPaymentAdviceModal: [],
      paymentAdviceModalOpen: false,
      paymentAdviceModalBackDrop: false,

      // collection data--for transaction Ref No
      allArcCollectionData: [],
      OriginalAllArcCollectionData: [],

      // import effitrac / tally
      openImportEffitracDrawer: false,
      effitracFetchFromData: {},

      // pagination state
      page: 0,
      rowsPerPage: 25,
      rowCount: 0,
      searchInput: "",

      // Select Add Payment Advice (select Bill*)
      pageAddPayment: 0,
      rowsPerPageAddPayment: 25,
      rowCountAddPayment: 0,

      uploadHistoryTableData: [],
      // showUploadHistroyTable: false,
      flagForZoho: false,
      timer: 60,
      loading: true,
      // variableForTimer: null,
      erpConnectorModelOpen: false,
      erpConnectorName: '',
      erpDataExportLoading: false,
      importToCwsLoading: false,

      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: '',
      toPeriod: null,

      // ---------------------------------------------------------------
      // IN-GRID MULTI-FIELD FILTER (same pattern as the other Data Upload
      // screens): a dedicated filter row sits directly under the sticky
      // grouped header, one compact box per column. Each box takes a
      // comma-separated "is any of" list, and every typed box is combined
      // (AND/OR) into a SINGLE apply.
      // ---------------------------------------------------------------
      // inlineFilterValues: what's currently typed into each column's box,
      // keyed by field — draft state, not yet sent to the backend.
      inlineFilterValues: {},
      // appliedFilters: the conditions actually in effect on the table.
      //   Each condition: { field, value } — value is the raw comma string.
      appliedFilters: [],
      // filterMatchType: "AND" (every filled column must match) or "OR"
      // (any filled column matching is enough).
      filterMatchType: "AND",
      // Mirrors appliedFilters into the shape sent to the backend; kept in
      // state so pagination handlers can tell "filtered" from "unfiltered".
      activeFilters: null,

      // ---------------------------------------------------------------
      // COMMON FILTER PANEL — one "Filter" button opens a compact side
      // panel next to the table (Basic filters open, Advanced collapsed).
      // "Apply Filters" commits everything in a SINGLE api call through the
      // same appliedFilters / applyDynamicFilters flow used above.
      // ---------------------------------------------------------------
      filterPanelOpen: false,
      advancedFiltersOpen: false,
      // draftValues: what is typed in the panel, keyed by column key.
      draftValues: {},
    };
  }

  // ---------------------------------------------------------------------
  // COLUMNS for the Payment Advice Details grid — one entry per key
  // returned by /get_vendor_payment_details. `group` drives the colored
  // group-band row, `width` (px) gives every header / filter box / cell a
  // fixed size so the sticky header, filter row and data all line up
  // exactly; the table scrolls horizontally instead of squeezing columns.
  // An optional `render` formats the cell value (e.g. currency for Amount
  // Paid).
  // IMPORTANT: columns that share a group must stay next to each other in
  // these arrays, because the group band is built from consecutive columns.
  // ---------------------------------------------------------------------
  filterableColumns = [
    // Vendor
    { key: "vendorName", label: "Vendor Name", group: "Vendor", width: 240 },
    { key: "erpVendorCode", label: "ERP Vendor Code", group: "Vendor", width: 150 },
    { key: "vendorCode", label: "Vendor Code", group: "Vendor", width: 120 },
    { key: "vendorGstin", label: "GSTIN", group: "Vendor", width: 170 },
    { key: "vendorPan", label: "PAN", group: "Vendor", width: 130 },

    // Bill
    { key: "invoiceNo", label: "Bill Number", group: "Bill", width: 170 },
    { key: "invoiceDate", label: "Bill Date", group: "Bill", width: 130 },

    // Payment
    { key: "paymentDate", label: "Payment Date", group: "Payment", width: 140 },
    { key: "amountPaid", label: "Amount Paid", group: "Payment", width: 150, render: (row) => numberFormat(row.amountPaid) },
    { key: "transactionRefNumber", label: "Transaction Ref No", group: "Payment", width: 190 },
    { key: "transactionType", label: "Transaction Type", group: "Payment", width: 160 },
    { key: "adjustmentMethod", label: "Adjustment Method", group: "Payment", width: 170 },
    { key: "voucherId", label: "Voucher ID", group: "Payment", width: 160 },

    // Other
    { key: "orgCode", label: "Org Code", group: "Other", width: 100 },
  ];

  // Trailing, display-only columns (not filterable) — still part of the
  // grouped header so the colored bands cover the full table width.
  nonFilterableColumns = [
    { key: "createDate", label: "Create Date", group: "Record Info", width: 170 },
    { key: "modifyDate", label: "Modify Date", group: "Record Info", width: 170 },
    { key: "created_date", label: "Created Date (System)", group: "Record Info", width: 190 },
    { key: "modified_date", label: "Modified Date (System)", group: "Record Info", width: 190 },
  ];

  // Fixed width (px) for the trailing sticky "SHOW" column.
  SHOW_COL_WIDTH = 70;

  // Fixed heights (px) of the two sticky header rows. The label row and the
  // filter row use these to compute their sticky `top` offsets, so the three
  // rows stack exactly with no gap or overlap.
  GROUP_ROW_HEIGHT = 30;
  LABEL_ROW_HEIGHT = 32;

  // Deep teal accent — same color used throughout the filter UI.
  ACCENT = "#0f766e";

  // Header colours — subtle tints of the app's navy (#03406f) on neutral greys.
  HEADER_GROUP_BG = "#e6ecf2";
  HEADER_LABEL_BG = "#f5f7f9";
  HEADER_TEXT = "#03406f";
  HEADER_BORDER = "#d3dce5";

  // Filter panel sections. Basic filters are open by default; every other
  // filterable column goes into the collapsed Advanced section.
  BASIC_FILTER_KEYS = [
    "vendorName",
    "erpVendorCode",
    "vendorGstin",
    "vendorPan",
    "invoiceNo",
    "invoiceDate",
    "paymentDate",
    "transactionRefNumber",
  ];

  // Same value on every row of an entity, so filtering on it is useless.
  FILTER_EXCLUDED_KEYS = ["orgCode"];

  // Columns shown as a dropdown in the filter panel (values used by the
  // Add/Edit forms). Yes/No-style columns are dropdowns.
  FILTER_DROPDOWN_OPTIONS = {
    transactionType: ["Bank", "Cash"],
    // Seen in the response: "On Account", "Agst Ref". "New Ref" and "Advance" are
    // the other standard bill-allocation types.
    adjustmentMethod: ["Agst Ref", "New Ref", "Advance", "On Account"],
  };

  getBasicFilterColumns = () =>
    this.BASIC_FILTER_KEYS.map((k) =>
      this.filterableColumns.find((c) => c.key === k)
    ).filter(Boolean);

  getAdvancedFilterColumns = () =>
    this.filterableColumns.filter(
      (c) =>
        !this.BASIC_FILTER_KEYS.includes(c.key) &&
        !this.FILTER_EXCLUDED_KEYS.includes(c.key)
    );

  getFieldMeta = (fieldKey) =>
    this.filterableColumns.find((c) => c.key === fieldKey) ||
    this.filterableColumns[0];

  // Every column, filterable or not.
  allColumns = () => [...this.filterableColumns, ...this.nonFilterableColumns];

  // Color band per group.
  GROUP_COLORS = {
    "Vendor": "#0f766e",
    "Bill": "#0e7490",
    "Payment": "#0369a1",
    "Other": "#1d4ed8",
    "Record Info": "#475569",
  };

  // Distinct groups, in first-seen order, with how many columns each spans
  // — drives the top header row's colSpan per group band.
  getColumnGroups = () => {
    const groups = [];
    this.allColumns().forEach((col) => {
      const existing = groups.find((g) => g.name === col.group);
      if (existing) {
        existing.span += 1;
      } else {
        groups.push({ name: col.group, span: 1 });
      }
    });
    return groups;
  };

  // Total pixel width of every column belonging to a given group — used to
  // size the group-band <th> so it lines up exactly with the columns below it.
  getGroupWidth = (groupName) =>
    this.allColumns()
      .filter((c) => c.group === groupName)
      .reduce((sum, c) => sum + c.width, 0);

  // Sum of every column's width plus the sticky SHOW column — used as the
  // table's min-width so the horizontal scrollbar kicks in instead of the
  // browser squeezing columns to fit.
  getTableMinWidth = () =>
    this.allColumns().reduce((sum, c) => sum + c.width, this.SHOW_COL_WIDTH);

  // Splits a raw string on commas into trimmed, non-empty, de-duplicated
  // values. Used for every field's value box so a person can type or paste
  // "abc ltd, mr.gg, amazon" into one field and match any of them.
  parseBulkFilterValues = (raw) => {
    return Array.from(
      new Set(
        (raw || "")
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v.length > 0)
      )
    );
  };

  handleAutoSyncChange = (checked) => {
    this.setState({ autoSync: checked });
  };

  handlePageChange = (newPage) => {
    console.log('Page change requested:', newPage);
    this.setState({ page: newPage, loading: true }, () => {
      this.uploadReport(this.props.id, newPage, this.state.perPage);
    });
  };
  

  handleNextPage = (event) => {
    const { errorPage, perErrorPages, errortotal } = this.state;
    const totalPages = Math.ceil(errortotal / perErrorPages);

    if (errorPage < totalPages) {
      const newPage = errorPage + 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handlePreviousPage = (event) => {
    const { errorPage } = this.state;

    if (errorPage > 1) {
      const newPage = errorPage - 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handleRowsPerPageChange = (index, value) => {
    console.log(`Changing rows per page to ${value}`);
    this.setState(
      {
        perErrorPages: value,
        errorPage: 1,
      },
      () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, 1);
      }
    );
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          newPage,
          this.state.rowsPerPage
        );
      } else {
        this.vendorPaymentGetApi(this.state.searchInput);
      }
    });
  };

  handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          0,
          newRowsPerPage
        );
      } else {
        this.vendorPaymentGetApi(this.state.searchInput);
      }
    });
  };
  // table serach
  handleSearchInputChange = (event) => {
    this.setState(
      { searchInput: event.target.value, page: 0, rowsPerPage: 25 },
      () => {
        if (this.state.appliedFilters.length > 0) {
          this.applyDynamicFilters(
            this.state.appliedFilters,
            this.state.filterMatchType,
            0,
            this.state.rowsPerPage
          );
        } else {
          this.vendorPaymentGetApi(this.state.searchInput);
        }
      }
    );
  };

  //Select Add Payment Advice (select Bill*)
  handleChangePageForPaymentAdvice = (event, newPage) => {
    this.setState({ pageAddPayment: newPage }, () => {
      this.getSellerInvoiceDataApi(this.state.paymentAdviceModalSearchInput);
    });
  };

  handleChangeRowsPerPageForPaymentAdvice = (event) => {
    this.setState(
      { rowsPerPageAddPayment: +event.target.value, pageAddPayment: 0 },
      () => {
        this.getSellerInvoiceDataApi(this.state.paymentAdviceModalSearchInput);
      }
    );
  };

  // table serach
  arcPaymentAdviceModalSearch = (event) => {
    this.setState(
      {
        paymentAdviceModalSearchInput: event.target.value,
        pageAddPayment: 0,
        rowsPerPageAddPayment: 25,
      },
      () => {
        this.getSellerInvoiceDataApi(this.state.paymentAdviceModalSearchInput);
      }
    );
  };

  // Vendor payment advice get api
  vendorPaymentGetApi = (serachIn) => {
    axios
      .post(`/get_vendor_payment_details`, {
        number_of_rows_per_page: this.state.rowsPerPage,
        page_number: this.state.page,
        search_text: serachIn,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allArcPaymentAdviceData: res.data.record,
          OriginalAllArcPaymentAdviceData: res.data.record,
          rowCount: res?.data?.row_count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Filter API call — takes the { match_type, conditions } payload built by
  // applyDynamicFilters and posts it ONCE for all active conditions, along
  // with pagination, and tracks the currently-applied filters so the
  // page/rowsPerPage handlers can resend them on subsequent pages.
  // If your backend route differs, just change the URL below.
  vendorPaymentFilterApi = (
    filters = {},
    page = this.state.page,
    rowsPerPage = this.state.rowsPerPage
  ) => {
    this.setState({ loading: true, activeFilters: filters });

    axios
      .post(`/get_vendor_payment_detailsFilter`, {   // ← change URL if your route is different
        business_entity_id: localStorage.getItem("business_entity_id"),
        search_text: this.state.searchInput || "",
        filters: filters,
        number_of_rows_per_page: rowsPerPage,
        page_number: page,
      })
      .then((res) => {
        this.setState({
          allArcPaymentAdviceData: res.data.record || [],
          OriginalAllArcPaymentAdviceData: res.data.record || [],
          rowCount: res.data.row_count || 0,
          loading: false,
          page: page,
          rowsPerPage: rowsPerPage,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        toast.error("Failed to fetch filtered data");
      });
  };

  // seller invoice get api function
  getSellerInvoiceDataApi = (serachIn) => {
    axios
      .post(`/get_vendor_invoice_details`, {
        number_of_rows_per_page: this.state.rowsPerPageAddPayment,
        page_number: this.state.pageAddPayment,
        search_text: serachIn,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          invoiceApiDataForPaymentAdviceModal: res.data.record,
          invoiceApiSearchDataForPaymentAdviceModal: res.data.record,
          rowCountAddPayment: res?.data?.row_count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // seller collection get api function
  getAllSellerCollectionData = () => {
    axios
      .get(
        `/arc/sellerCollection/${localStorage.getItem("business_entity_id")}`
      )
      .then((res) => {
        this.setState({
          allArcCollectionData: res.data.records,
          OriginalAllArcCollectionData: res.data.records,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSellerPaymentAdviceLastUploadDate = () => {
    const customer = "SellerPaymentAdvice";
    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id"
        )}/${customer}`
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = dateFormatWithDash(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDate: Date,
          lastUploadTime: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getApiForClientID = () => {
    axios
      .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        res.data.record
          .filter((v) => v.source_system === "ZOHO")
          .map((value) =>
            localStorage.setItem("Client_ID", value.connection_info.client_id)
          );
        res?.data?.record.filter((v) => {
          if (v.source_system === "Effitrac" || v.source_system === "Tally") {
            localStorage.setItem("Trigger_Effitrac/Tally_Button", "true");
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // getting history table data of upload
  getHistoryTableUploadData = () => {
    axios
      .get(
        `/arc/get_data_upload_history/${localStorage.getItem(
          "business_entity_id"
        )}/${15}`
      )
      .then((res) => {
        this.setState({ uploadHistoryTableData: res.data.record });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getErpConnectorName = () => {
    axios.get(`/arc/verify_erp_data_pull_eligibility/${localStorage.getItem('business_entity_id')}`)
      .then((res) => {
        if (res?.data?.status) {
          this.setState({ erpConnectorName: res?.data?.data })
        }
      }).catch((err) => {

      })
  }


  componentDidMount() {
    let domain = new URL(window.location).searchParams;
    let code = domain.get("code");
    code && this.setState({ grantToken: code });

    let drawer = domain.get("drawer");
    drawer &&
      this.setState({
        openZohoDrawer: true,
        messageForConnection: "Connection Established",
        buttonColor: "green",
      });

    let url = window.location;
    this.setState({ url: url.origin });
    localStorage.setItem("urlOrigin", url.origin);
    localStorage.setItem("pathName", url.pathname);

    this.getApiForClientID();
    this.vendorPaymentGetApi(); // Table
    this.getSellerInvoiceDataApi(); // Add Payment Advice -- Select Invoice
    this.getAllSellerCollectionData();
    this.getSellerPaymentAdviceLastUploadDate(); // Update Date and Time
    this.getHistoryTableUploadData();
    this.getErpConnectorName()
  }

  componentDidUpdate() {
    if (this.state.buttonColor === "green" && !this.state.flagForZoho) {
      this.setState({ flagForZoho: true });
      variableForTimer = setInterval(() => {
        this.setState((prevstate) => ({ timer: prevstate.timer - 1 }));
      }, 1000);
    }
    if (this.state.timer === 0) {
      clearInterval(variableForTimer);
      this.setState({ flagForZoho: false, timer: 60, buttonColor: "red" });
    }
  }

  // --------------------------------------------ARC transaction  modal[ customer table]-------------------------------

  //Indian Rupee Formate
  indianRupeesFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumSignificantDigits: 10,
    }).format(value);

  // arc paymentAdvice table header[customer table data in modal]---
  paymentAdviceModal_TableHeader() {
    const tableHeader = [
      "Vendor Name",
      "Vendor GSTIN",
      "Invoice Number",
      "select",
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  paymentAdviceModal_tableBody() {
    const addPaymentAdvice = (dataForSelectInvoice) => {
      let invoiceDateForAdd = dataForSelectInvoice.invoiceDate;
      let invoiceDateDisplayForAdd = invoiceDateForAdd
        .split("-")
        .reverse()
        .join("-");
      const invoiceDateConvertingIntoStringForAdd =
        invoiceDateDisplayForAdd.toString();
      this.setState((prevState) => ({
        addPaymentAdviceData: {
          ...prevState.addPaymentAdviceData,
          vendorGstin: dataForSelectInvoice.vendorGstin,
          invoiceNumber: dataForSelectInvoice.invoiceNumber,
          invoiceDate: invoiceDateConvertingIntoStringForAdd,
          erpVendorCode: dataForSelectInvoice.erpVendorCode,
          amountPaid: null,
          paymentDate: "",
          transactionRefNumber: "",
          tdsAmount: null,
          bankAccountNumber: "",
          typeOfTransactions: "",
        },
        invicedateForAddDisplay: dataForSelectInvoice.invoiceDate,
        paymentAdviceModalOpen: false,
        paymentAdviceModalBackDrop: false,
        paymentAdviceModalSearchInput: "",
      }));

      this.getSellerInvoiceDataApi();
    };

    if (
      this.state.invoiceApiDataForPaymentAdviceModal &&
      this.state.invoiceApiDataForPaymentAdviceModal.length >= 1
    ) {
      return this.state.invoiceApiDataForPaymentAdviceModal.map(
        (tableData, index) => {
          return (
            <tr key={index}>
              <td>{tableData.vendorName}</td>
              <td> {tableData.vendorGstin}</td>
              <td>{tableData.invoiceNumber}</td>
              <td>
                <AddCircleOutlineIcon
                  onClick={() => addPaymentAdvice(tableData)}
                />
              </td>
            </tr>
          );
        }
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colspan={8}>
            No data found!
          </td>
        </tr>
      );
    }
  }

  //-----------------Payment advice table search----------------
  handleSearchInputChangeForZohoAndEffitrack = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch(event);
    });
  };

  //excel download
  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  export_to_excel = (datafromfunction) => {
    let data = {};
    if (!this.state.erpConnectorModelOpen) {
      if (this.state.openZohoDrawer) {
        data = {
          zoho_data: datafromfunction,
          business_entity_id: localStorage.getItem("business_entity_id")
        }
      } else {
        data = {
          business_entity_id: localStorage.getItem("business_entity_id")
        }
      }
    } else {
      data = datafromfunction;
    }
    if (this.state.fromPeriod && this.state.toPeriod) {
      data['from_period'] = moment(this.state.fromPeriod).format("YYYY-MM-DD")
      data['to_period'] = moment(this.state.toPeriod).format("YYYY-MM-DD")
    }
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendor_payment_advice.xlsx`;

    axios
      .post("/vendor/vendorpaymentadvicedownload", data)
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((err) => {
        if (err.response.data.detail) {
          toast.error(err?.response?.data?.detail, { autoClose: 2000 });
        } else {
          toast.error("Server Error Try After Some Time", { autoClose: 2000 });
        }
      }).finally(() => {
        this.setState({ erpDataExportLoading: false })
      });
  };

  // Export All / Export Filtered (one button). No filters applied -> every
  // record, using the same request the existing Export sends with no period.
  // Filters applied -> only the records matching them: they are fetched from
  // the existing filter api (one page as big as the filtered result) and sent
  // to the same download api in `records`. Any column the filter response
  // lacks is filled with an empty value so every row has the same keys.
  exportall_to_excel = () => {
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendor_payment_advice.xlsx`;
    const businessEntityId = localStorage.getItem("business_entity_id");
    const filtered = this.state.appliedFilters.length > 0 && this.state.activeFilters;
    this.setState({ isExportingAll: true });

    const request = filtered
      ? axios
          .post(`/get_vendor_payment_detailsFilter`, {
            business_entity_id: businessEntityId,
            search_text: this.state.searchInput || "",
            filters: this.state.activeFilters,
            number_of_rows_per_page: Math.max(this.state.rowCount || 0, 1),
            page_number: 0,
          })
          .then((res) => {
            const records = (res?.data?.record || []).map((r) => {
              const row = { ...r };
              this.filterableColumns.forEach((c) => {
                if (row[c.key] === undefined || row[c.key] === null) row[c.key] = "";
              });
              return row;
            });
            if (records.length === 0) {
              toast.error("No records found for the selected filters", { autoClose: 2000 });
              return null;
            }
            return axios.post("/vendor/vendorpaymentadvicedownload", {
              business_entity_id: businessEntityId,
              records: records,
            });
          })
      : axios.post("/vendor/vendorpaymentadvicedownload", {
          business_entity_id: businessEntityId,
        });

    request
      .then((res) => {
        if (res) this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        console.log(error);
        toast.error(filtered ? "Failed to export filtered data" : "Failed to export all data", { autoClose: 2000 });
      })
      .finally(() => {
        this.setState({ isExportingAll: false });
      });
  };

 export_erp_data_to_excel = (apPointName, transId) => {
  this.setState({ erpDataExportLoading: true })
   const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendor_payment_advice.xlsx`;
  let data = [];
  const payLoadData = {
    'business_entity_id': localStorage.getItem('business_entity_id'),
    'api_point_name': apPointName,
    // 'is_import': true,
    'record_id': transId,
  }
  axios.post('/get_erp_connector_data', payLoadData)
    .then((res) => {
      if (res) {
          this.downloadBase64File(contentType, res.data.data, filename);
        // data = res?.data?.data
        // this.export_to_excel(data) // resets erpDataExportLoading internally
      } else {
        toast.error("Data not found. Please try again later.", {
          autoClose: 2000,
        });
        this.setState({ erpDataExportLoading: false }); // <-- FIX
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Error exporting data", {
        autoClose: 2000,
      });
      this.setState({ erpDataExportLoading: false }); // <-- FIX
    });
};

  globalSearch = (event) => {
    let { searchInput } = this.state;

    let searchAdminData = this.state.oldEffitracData.filter((value) => {
      const query = searchInput.trim().toLowerCase();
      return (
        String(value.erpVendorCode).toLowerCase().indexOf(query) >= 0 ||
        String(value.vendorGstin).toLowerCase().indexOf(query) >= 0 ||
        String(value.invoiceNumber).toLowerCase().indexOf(query) >= 0 ||
        String(value.transactionRefNumber).toLowerCase().indexOf(query) >= 0 ||
        String(moment(value.paymentDate).format("DD-MM-YYYY"))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(moment(value.paymentDate).format("DD/MM/YYYY"))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(value.bankAccountNumber).toLowerCase().indexOf(query) >= 0 ||
        String(value.typeOfTransactions).toLowerCase().indexOf(query) >= 0 ||
        String(moment(value.invoiceDate).format("DD-MM-YYYY"))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(moment(value.invoiceDate).format("DD/MM/YYYY"))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(this.indianRupeesFormat(value.amountPaid))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(value.amountPaid).toLowerCase().indexOf(query) >= 0 ||
        String(this.indianRupeesFormat(value.tdsAmount))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(value.tdsAmount).toLowerCase().indexOf(query) >= 0
      );
    });
    this.setState({ effitracData: searchAdminData });
  };

  // ------------------------Payment advice file uplpad-----------------------
  fileUploader = (event, serachIn) => {
    this.setState({ loading: true });
    const file_data = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file_data);
    let dis = this;

    reader.onload = function () {
      let file_value = reader.result;
      axios
        .post(`/vendor/vendorpaymentadvice`, {
          file: file_value,
          org_code: localStorage.getItem("business_entity_id"),
        })
        .then((data) => {
          if (!data || !data.data) {
            dis.setState({ loading: false });
            return;
          }

          dis.getHistoryTableUploadData();
          dis.setState({ loading: false });
          // axios
          //   .get(`/get_vendor_payment_details`, {
          //     number_of_rows_per_page: this.state.rowsPerPage,
          //     page_number: this.state.page,
          //     search_text: serachIn,
          //     business_entity_id: localStorage.getItem('business_entity_id'),
          //   })
          //   .then((res) => {
          //     dis.setState({
          //       allArcCustomerDataPurchase: res.data.record,
          //       OriginalDataAllArcCustomerDataPurchase: res.data.record,
          //       rowCount: res.data.row_count,
          //     });
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        })
        .catch((error) => {
          dis.setState({ loading: false });
          const errorMessage = error?.response?.data?.message;
          if (errorMessage) {
            toast.error(errorMessage, { autoClose: 5000 });
          } else {
          toast.error("Unable To Upload Template Try After Some Time", {
            autoClose: 2000,
          });
          }
          // dis.setState({
          //   error: error,
          //   total_records: 0,
          // });
        });
    };
  };
  // refresh Upload History Table using refresh button
  refreshUploadHistoryTable = () => {
    this.getHistoryTableUploadData();
    this.vendorPaymentGetApi();
  };

  // -----------------------------------------------------------------------
  // IN-GRID MULTI-FIELD FILTER
  // -----------------------------------------------------------------------
  // Every filterable column has its own compact box directly in the filter
  // row under the table header. Typing into several boxes at once stages
  // several conditions; nothing is sent to the backend until "Apply" (or
  // Enter) fires ONCE for the whole set.

  // Patches one column's staged (not-yet-applied) value.
  handleInlineFilterChange = (field, rawValue) => {
    this.setState((prevState) => ({
      inlineFilterValues: {
        ...prevState.inlineFilterValues,
        [field]: rawValue,
      },
    }));
  };

  getInlineFilterValue = (field) => this.state.inlineFilterValues[field] ?? "";

  // Clears just one column's box (its little "×" adornment), without
  // touching any other staged column or applying anything.
  clearInlineFilterField = (field) => {
    this.setState((prevState) => ({
      inlineFilterValues: { ...prevState.inlineFilterValues, [field]: "" },
    }));
  };

  // True once at least one column box has something typed into it that
  // hasn't been applied yet — drives the "Apply Filters" affordance.
  hasStagedFilterChanges = () => {
    const { inlineFilterValues, appliedFilters } = this.state;
    const appliedByField = Object.fromEntries(
      appliedFilters.map((c) => [c.field, c.value])
    );
    return this.filterableColumns.some((col) => {
      const staged = (inlineFilterValues[col.key] ?? "").trim();
      const applied = (appliedByField[col.key] ?? "").trim();
      return staged !== applied;
    });
  };

  stagedFilterFieldCount = () =>
    Object.values(this.state.inlineFilterValues).filter(
      (v) => (v ?? "").toString().trim() !== ""
    ).length;

  // Single action: reads every column's box, keeps only the ones with a
  // value, and fires ONE api call for the combined set.
  applyInlineFilters = () => {
    const conditions = this.filterableColumns
      .map((col) => ({
        field: col.key,
        value: (this.state.inlineFilterValues[col.key] ?? "").trim(),
      }))
      .filter((c) => c.value !== "");

    this.setState({ appliedFilters: conditions, page: 0 }, () =>
      this.applyDynamicFilters(
        conditions,
        this.state.filterMatchType,
        0,
        this.state.rowsPerPage
      )
    );
  };

  // Wipes every column's box and whatever was applied, in one shot.
  handleClearAllFilters = () => {
    this.setState(
      { inlineFilterValues: {}, draftValues: {}, appliedFilters: [], page: 0 },
      () =>
        this.applyDynamicFilters([], this.state.filterMatchType, 0, this.state.rowsPerPage)
    );
  };

  // -----------------------------------------------------------------------
  // COMMON FILTER PANEL — state handlers
  // -----------------------------------------------------------------------

  // The Filter button toggles the panel. When opening, the panel is
  // pre-filled with whatever is currently applied so the person always
  // sees what is live.
  openFilterPanel = () => {
    if (this.state.filterPanelOpen) {
      this.setState({ filterPanelOpen: false });
      return;
    }
    const draftValues = {};
    this.state.appliedFilters.forEach((c) => {
      draftValues[c.field] = c.value;
    });
    this.setState({ filterPanelOpen: true, draftValues });
  };

  // Closing without pressing "Apply Filters" discards unapplied edits.
  closeFilterPanel = () => {
    this.setState({ filterPanelOpen: false });
  };

  toggleAdvancedFilters = () => {
    this.setState((prev) => ({ advancedFiltersOpen: !prev.advancedFiltersOpen }));
  };

  // Chip cross: removes ONE applied filter and reloads the table.
  removeAppliedFilter = (field) => {
    const conditions = this.state.appliedFilters.filter((c) => c.field !== field);
    this.setState(
      (prev) => {
        const draftValues = { ...prev.draftValues };
        delete draftValues[field];
        const inlineFilterValues = { ...prev.inlineFilterValues };
        delete inlineFilterValues[field];
        return { appliedFilters: conditions, draftValues, inlineFilterValues, page: 0 };
      },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  handleDraftValueChange = (key) => (event) => {
    const value = event.target.value;
    this.setState((prev) => ({
      draftValues: { ...prev.draftValues, [key]: value },
    }));
  };

  // Excel copy-paste brings multiple values separated by newlines (rows) or
  // tabs (columns), with no commas. Convert that shape into the same
  // comma-separated "is any of" format, appending to whatever is typed.
  handleFilterValuePaste = (key) => (e) => {
    const pasted = e.clipboardData.getData("text");
    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // single value — default paste

    e.preventDefault();
    const joined = pasted
      .split(/[\r\n\t]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0)
      .join(", ");
    if (!joined) return;

    this.setState((prev) => {
      const current = (prev.draftValues[key] || "").replace(/\s+$/, "");
      const next = !current
        ? joined
        : current.endsWith(",")
        ? `${current} ${joined}`
        : `${current}, ${joined}`;
      return { draftValues: { ...prev.draftValues, [key]: next } };
    });
  };

  // Enter inside any input applies the filter.
  handleFilterKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.applyFilterFromPanel();
    }
  };

  // "Apply Filters" — every non-empty input becomes a condition, and the
  // whole set is sent in ONE api call. The panel closes afterwards.
  applyFilterFromPanel = () => {
    const conditions = [
      ...this.getBasicFilterColumns(),
      ...this.getAdvancedFilterColumns(),
    ]
      .map((c) => ({
        field: c.key,
        value: (this.state.draftValues[c.key] || "").trim(),
      }))
      .filter((c) => c.value !== "");

    this.setState(
      { appliedFilters: conditions, filterPanelOpen: false, page: 0 },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  // Builds the backend payload from the current conditions and either calls
  // the filter API (when conditions exist) or falls back to the normal
  // paginated listing (when the filter set is empty). Every condition is
  // sent as operator "in" — "field value is any of these".
  applyDynamicFilters = (
    conditions = this.state.appliedFilters,
    matchType = this.state.filterMatchType,
    page = 0,
    rowsPerPage = this.state.rowsPerPage
  ) => {
    if (!conditions || conditions.length === 0) {
      this.setState({ activeFilters: null });
      this.vendorPaymentGetApi(this.state.searchInput);
      return;
    }

    const payload = conditions.map((c) => ({
      field: c.field,
      operator: "in",
      value: this.parseBulkFilterValues(c.value),
    }));

    const filters = { match_type: matchType, conditions: payload };
    this.setState({ activeFilters: filters });
    this.vendorPaymentFilterApi(filters, page, rowsPerPage);
  };

  CollectionListActions = () => (
    <div>
      <a
        href={VendorPaymentAdvice}
        download={"vendor_payment_advice.xlsx"}
        style={{ textDecoration: "none" }}
      >
        {" "}
        <Button component="label" size="small" color="primary">
          <GetAppIcon style={{ fontSize: "20px" }} />
          DOWNLOAD TEMPLATE
        </Button>
      </a>
      {canWrite("UPLOADING PURCHASE") && (
      <Button component="label" size="small" color="primary">
        <PublishIcon style={{ fontSize: "20px" }} />
        UPLOAD TEMPLATE{" "}
        <input
          accept=".xlsx"
          name="file"
          type="file"
          value=""
          hidden
          onChange={this.fileUploader}
        />
      </Button>
      )}
      <Button
        component="label"
        size="small"
        color="primary"
        style={{ float: "right" }}
        onClick={this.refreshUploadHistoryTable}
      >
        <RefreshIcon style={{ fontSize: "20px" }} />
        Refresh
      </Button>
    </div>
  );
  // ----------------Payment advice file upload response end------------

  // -----------------------------------------------------------------------
  // IN-GRID FILTER — rendering
  // -----------------------------------------------------------------------
  // The slim bar directly above the table. Returns null when there is
  // nothing to show (no applied filters, nothing staged) so it never adds
  // visual weight to the page until it's actually useful.
  renderFilterActionBar = () => {
    const stagedCount = this.stagedFilterFieldCount();
    const hasStaged = this.hasStagedFilterChanges();
    const hasApplied = this.state.appliedFilters.length > 0;

    if (!hasStaged && !hasApplied) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
          padding: "7px 14px",
          marginBottom: "6px",
          borderRadius: "8px",
          background: hasStaged
            ? `linear-gradient(90deg, ${this.ACCENT}, #115e59)`
            : "#f1f5f9",
          color: hasStaged ? "#ffffff" : "#334155",
          transition: "background 0.2s ease",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "12.5px" }}>
          <TuneIcon style={{ fontSize: "16px" }} />
          <span>
            {hasStaged
              ? `${stagedCount} field${stagedCount === 1 ? "" : "s"} ready to filter`
              : `${this.state.appliedFilters.length} filter${
                  this.state.appliedFilters.length === 1 ? "" : "s"
                } active`}
          </span>
        </div>

        <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
          {hasApplied && (
            <button
              type="button"
              onClick={this.handleClearAllFilters}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "12px",
                cursor: "pointer",
                color: hasStaged ? "rgba(255,255,255,0.9)" : this.ACCENT,
                textDecoration: "underline",
              }}
            >
              Clear all
            </button>
          )}
          {hasStaged && (
            <button
              type="button"
              onClick={this.applyInlineFilters}
              style={{
                background: "#ffffff",
                color: this.ACCENT,
                border: "none",
                borderRadius: "999px",
                padding: "4px 18px",
                fontSize: "12px",
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
              }}
            >
              Apply Filters
            </button>
          )}
        </div>
      </div>
    );
  };

  // -----------------------------------------------------------------------
  // COMMON FILTER PANEL — rendering
  // -----------------------------------------------------------------------
  renderFilterButton = () => {
    const appliedCount = this.state.appliedFilters.length;
    return (
      <button
        type="button"
        className="button-outlined-primary"
        onClick={this.openFilterPanel}
        style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
      >
        <FilterAltOutlinedIcon style={{ fontSize: "18px" }} />
        {appliedCount > 0 ? `Filter (${appliedCount})` : "Filter"}
      </button>
    );
  };

  // One label + white input (dropdown for the columns in FILTER_DROPDOWN_OPTIONS).
  // Filter-panel columns that take a date: they use the shared DatePicker.
  FILTER_DATE_KEYS = ["invoiceDate", "paymentDate"];

  // Dates are filtered as YYYY-MM-DD; chips show DD-MM-YYYY.
  toDisplayDate = (v) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || "");
    return m ? `${m[3]}-${m[2]}-${m[1]}` : v;
  };

  renderFilterField = (col) => {
    const { draftValues } = this.state;
    const common = {
      fullWidth: true,
      size: "small",
      variant: "outlined",
      value: draftValues[col.key] ?? "",
      onChange: this.handleDraftValueChange(col.key),
      InputProps: { style: { background: "#fff" } },
    };
    const options = this.FILTER_DROPDOWN_OPTIONS[col.key];

    return (
      <div key={col.key} style={{ minWidth: 0 }}>
        <label style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}>
          {col.label}
        </label>
        {this.FILTER_DATE_KEYS.includes(col.key) ? (
          <ValidatorForm onSubmit={() => {}} style={{ margin: 0 }}>
            <DatePicker
              fullWidth
              name={`filter_${col.key}`}
              placeholder="Select date"
              value={draftValues[col.key] ? moment(draftValues[col.key], "YYYY-MM-DD").toDate() : ""}
              onChange={(v) =>
                this.handleDraftValueChange(col.key)({
                  target: { value: v && moment(v).isValid() ? moment(v).format("YYYY-MM-DD") : "" },
                })
              }
            />
          </ValidatorForm>
        ) : options ? (
          <TextField {...common} select SelectProps={{ native: true }}>
            <option value="">Select</option>
            {options.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </TextField>
        ) : (
          <TextField
            {...common}
            placeholder={`Enter ${col.label.toLowerCase()}`}
            onPaste={this.handleFilterValuePaste(col.key)}
            onKeyDown={this.handleFilterKeyDown}
          />
        )}
      </div>
    );
  };

  renderFilterPanel = () => {
    const { filterPanelOpen, draftValues, advancedFiltersOpen } = this.state;
    if (!filterPanelOpen) return null;

    const advancedColumns = this.getAdvancedFilterColumns();
    const advancedCount = advancedColumns.filter(
      (c) => (draftValues[c.key] || "").trim() !== ""
    ).length;

    const gridStyle = {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    };

    return (
      <div
        style={{
          width: 440,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          minHeight: 360,
          // Keeps the panel table-sized; the body scrolls inside.
          maxHeight: "calc(100vh - 260px)",
          border: `1px solid ${this.HEADER_TEXT}`,
          borderRadius: 4,
          background: "#fff",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(3,64,111,0.12)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "6px 6px 6px 14px",
            background: this.HEADER_TEXT,
            color: "#ffffff",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: 600 }}>Filters</span>
          <Tooltip title="Close" arrow>
            <IconButton size="small" onClick={this.closeFilterPanel}>
              <ClearIcon style={{ fontSize: "16px", color: "#ffffff" }} />
            </IconButton>
          </Tooltip>
        </div>

        {/* Body: Basic (open) + Advanced (collapsed) */}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            padding: "12px 14px",
            background: "#eef3f8",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              marginBottom: "10px",
            }}
          >
            Basic Filters
          </div>
          <div style={gridStyle}>
            {this.getBasicFilterColumns().map((col) => this.renderFilterField(col))}
          </div>

          <div
            role="button"
            onClick={this.toggleAdvancedFilters}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              marginTop: "14px",
              padding: "10px 0",
              borderTop: `1px solid ${this.HEADER_BORDER}`,
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              userSelect: "none",
            }}
          >
            <span>
              {advancedCount > 0
                ? `Advanced Filters (${advancedCount})`
                : "Advanced Filters"}
            </span>
            {advancedFiltersOpen ? (
              <ExpandLessIcon style={{ fontSize: "20px" }} />
            ) : (
              <ExpandMoreIcon style={{ fontSize: "20px" }} />
            )}
          </div>
          {advancedFiltersOpen && (
            <div style={gridStyle}>
              {advancedColumns.map((col) => this.renderFilterField(col))}
            </div>
          )}
        </div>

        {/* Footer — bottom right */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "10px 14px",
            background: this.HEADER_GROUP_BG,
            borderTop: `1px solid ${this.HEADER_BORDER}`,
          }}
        >
          <button
            type="button"
            className="button-outlined-secondary"
            onClick={this.handleClearAllFilters}
          >
            Clear All
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={this.applyFilterFromPanel}
          >
            Apply Filters
          </button>
        </div>
      </div>
    );
  };

  // Applied filters as small chips, each with its own cross.
  renderAppliedFilterChips = () => {
    const { appliedFilters } = this.state;
    if (appliedFilters.length === 0) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          marginBottom: "8px",
        }}
      >
        {appliedFilters.map((c) => (
          <Chip
            key={c.field}
            size="small"
            variant="outlined"
            label={`${this.getFieldMeta(c.field).label}: ${this.FILTER_DATE_KEYS.includes(c.field) ? this.toDisplayDate(c.value) : c.value}`}
            onDelete={() => this.removeAppliedFilter(c.field)}
            style={{
              maxWidth: 280,
              backgroundColor: this.HEADER_GROUP_BG,
              color: this.HEADER_TEXT,
              borderColor: this.HEADER_BORDER,
            }}
          />
        ))}
      </div>
    );
  };

  // ------------------------Payment advice table-----------------------
  // -----------------------------------------------------------------------
  // GROUPED HEADER — returns an array of TWO <tr> elements:
  //   1) the colored group-band row, each band spanning all of its columns
  //      via colSpan and sized to the total width of its columns, plus the
  //      trailing SHOW cell which spans both header rows
  //   2) the column-label row
  // The caller drops the array straight into <tbody> (NOT inside another
  // <tr>). Both rows have fixed heights so the sticky offsets of the label
  // row and the filter row stack exactly.
  // -----------------------------------------------------------------------
  arc_paymentAdvice_TableHeader() {
    const groups = this.getColumnGroups();

    const groupRow = (
      <tr key="group-row">
        {groups.map((g) => {
          const width = this.getGroupWidth(g.name);
          return (
            <th
              key={g.name}
              colSpan={g.span}
              style={{
                position: "sticky",
                top: 0,
                zIndex: 510,
                height: this.GROUP_ROW_HEIGHT,
                lineHeight: "18px",
                width: width,
                minWidth: width,
                maxWidth: width,
                padding: "6px 8px",
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                color: this.HEADER_TEXT,
                background: this.HEADER_GROUP_BG,
                textAlign: "center",
                borderRight: `1px solid ${this.HEADER_BORDER}`,
                borderBottom: `1px solid ${this.HEADER_BORDER}`,
                whiteSpace: "nowrap",
                boxSizing: "border-box",
              }}
            >
              {g.name}
            </th>
          );
        })}
        <th
          rowSpan={2}
          style={{
            position: "sticky",
            top: 0,
            right: 0,
            zIndex: 520,
            width: this.SHOW_COL_WIDTH,
            minWidth: this.SHOW_COL_WIDTH,
            maxWidth: this.SHOW_COL_WIDTH,
            backgroundColor: this.HEADER_GROUP_BG,
            color: this.HEADER_TEXT,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            textAlign: "center",
            verticalAlign: "middle",
            borderLeft: `1px solid ${this.HEADER_BORDER}`,
            borderBottom: `1px solid ${this.HEADER_BORDER}`,
            boxShadow: "-2px 0 4px rgba(0,0,0,0.06)",
            boxSizing: "border-box",
          }}
        >
          SHOW
        </th>
      </tr>
    );

    const labelRow = (
      <tr key="label-row">
        {this.allColumns().map((col) => (
          <th
            key={col.key}
            title={col.label}
            style={{
              position: "sticky",
              top: this.GROUP_ROW_HEIGHT,
              zIndex: 500,
              height: this.LABEL_ROW_HEIGHT,
              lineHeight: "18px",
              width: col.width,
              minWidth: col.width,
              maxWidth: col.width,
              backgroundColor: this.HEADER_LABEL_BG,
              padding: "6px 8px",
              fontSize: "11.5px",
              fontWeight: 600,
              color: "#334155",
              textAlign: "center",
              borderRight: `1px solid ${this.HEADER_BORDER}`,
              borderBottom: `1px solid ${this.HEADER_BORDER}`,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              boxSizing: "border-box",
            }}
          >
            {col.label.toUpperCase()}
          </th>
        ))}
      </tr>
    );

    return [groupRow, labelRow];
  }

  // The filter row itself — lives as a `<tr>` right under the label row,
  // inside the same table, one comma-separated box per filterable column.
  // Pressing Enter in any box applies every staged box at once. The
  // trailing display-only date columns have no filter, so they get plain
  // empty cells, and the cell under SHOW is pinned to the right edge.
  renderInlineFilterRow = () => {
    const filterRowTop = this.GROUP_ROW_HEIGHT + this.LABEL_ROW_HEIGHT;
    const appliedByField = Object.fromEntries(
      this.state.appliedFilters.map((c) => [c.field, c.value])
    );

    return (
      <tr>
        {this.filterableColumns.map((col) => {
          const value = this.getInlineFilterValue(col.key);
          const isApplied =
            value.trim() !== "" && (appliedByField[col.key] ?? "").trim() === value.trim();

          return (
            <td
              key={col.key}
              style={{
                position: "sticky",
                top: filterRowTop,
                zIndex: 400,
                width: col.width,
                minWidth: col.width,
                maxWidth: col.width,
                padding: "6px 10px",
                background: "#f0fdfa",
                borderBottom: `2px solid ${isApplied ? this.ACCENT : "#d9e6e4"}`,
                boxSizing: "border-box",
              }}
            >
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  type="text"
                  value={value}
                  onChange={(e) => this.handleInlineFilterChange(col.key, e.target.value)}
                  onPaste={(e) => {
                    // Excel copy-paste brings multiple values separated by
                    // newlines (one per row) or tabs (one per column), with
                    // no commas at all. Detect that shape and convert it
                    // into the same comma-separated "is any of" format this
                    // box expects, appending to whatever is already typed.
                    const pasted = e.clipboardData.getData("text");
                    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // plain single-value paste — let default happen

                    e.preventDefault();
                    const pastedValues = pasted
                      .split(/[\r\n\t]+/)
                      .map((v) => v.trim())
                      .filter((v) => v.length > 0);
                    if (pastedValues.length === 0) return;

                    const joined = pastedValues.join(", ");
                    const current = value.replace(/\s+$/, "");
                    const newValue =
                      current === ""
                        ? joined
                        : current.endsWith(",")
                        ? `${current} ${joined}`
                        : `${current}, ${joined}`;

                    this.handleInlineFilterChange(col.key, newValue);
                  }}
                  onKeyDown={(e) => {
                    // Enter applies every staged box at once — same effect
                    // as clicking "Apply Filters" in the bar above.
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.applyInlineFilters();
                    }
                  }}
                  placeholder={`e.g. ${col.label.toLowerCase()} 1, 2`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "transparent",
                    outline: "none",
                    fontSize: "12px",
                    fontFamily: "inherit",
                    padding: "3px 18px 3px 2px",
                    color: "#0f172a",
                    textAlign: "center",
                  }}
                />
                {value && (
                  <ClearIcon
                    onClick={() => this.clearInlineFilterField(col.key)}
                    style={{
                      position: "absolute",
                      right: 0,
                      fontSize: "14px",
                      color: "#94a3b8",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
            </td>
          );
        })}
        {this.nonFilterableColumns.map((col) => (
          <td
            key={`${col.key}_filter`}
            style={{
              position: "sticky",
              top: filterRowTop,
              zIndex: 400,
              width: col.width,
              minWidth: col.width,
              maxWidth: col.width,
              background: "#f0fdfa",
              borderBottom: "2px solid #d9e6e4",
              boxSizing: "border-box",
            }}
          />
        ))}
        <td
          style={{
            position: "sticky",
            top: filterRowTop,
            right: 0,
            zIndex: 410,
            width: this.SHOW_COL_WIDTH,
            minWidth: this.SHOW_COL_WIDTH,
            maxWidth: this.SHOW_COL_WIDTH,
            padding: "6px 10px",
            background: "#f0fdfa",
            borderBottom: "2px solid #d9e6e4",
            textAlign: "center",
            boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
            boxSizing: "border-box",
          }}
        >
          {this.state.appliedFilters.length > 0 && (
            <Tooltip title="Clear all filters">
              <IconButton size="small" onClick={this.handleClearAllFilters}>
                <ClearIcon style={{ fontSize: "16px", color: this.ACCENT }} />
              </IconButton>
            </Tooltip>
          )}
        </td>
      </tr>
    );
  };

  // table body
  arc_PaymentAdvice__data() {
    const showToggleDrawer = (
      amountPaid,
      bankAccountNumber,
      createDate,
      created_date,
      erpVendorCode,
      invoiceNo,
      modifyDate,
      modified_date,
      orgCode,
      paymentDate,
      tdsAmount,
      transactionRefNumber,
      typeOfTransactions,
      vendorCode,
      vendorGstin,
      vendorName,
      vendorPan,
      voucherId,
      invoiceDate,
      adjustmentMethod
    ) => {
      this.setState({
        showPaymentDetailsData: {
          showTransactionRefNo: transactionRefNumber,
          showTransactionType: typeOfTransactions,
          showPaymentDate: paymentDate,
          showAmountPaid: amountPaid,
          showTdsAmount: tdsAmount,
          showInvoiceDate: invoiceDate,
          showModifyDate: modifyDate,
          showCreateDate: createDate,
          created_date: created_date,
          modified_date: modified_date,
          showbankAccountNumber: bankAccountNumber,
          showvendorPan: vendorPan,
          showvoucherId: voucherId,
          showadjustmentMethod: adjustmentMethod
        },
        showDrawer: true,
      });
    };

    const editPaymentAdvice = (
      amountPaid,
      bankAccountNumber,
      createDate,
      created_date,
      erpVendorCode,
      invoiceDate,
      invoiceNumber,
      modifyDate,
      modified_date,
      orgCode,
      paymentDate,
      tdsAmount,
      transactionRefNumber,
      typeOfTransactions,
      vendorCode,
      vendorGstin,
      vendorName
    ) => {
      let invoice = invoiceDate;
      let invoiceDateDisplay = invoice.split("-").reverse().join("-");
      const invoiceDateConvertingIntoString = invoiceDateDisplay.toString();
      let PaymentDate = paymentDate;
      let PaymentDateReverse = PaymentDate.split("-").reverse().join("-");
      const PaymentDateConvertingIntostring = PaymentDateReverse.toString();

      this.setState({
        editPaymentAdviceData: {
          amountPaid: amountPaid,
          transactionRefNumber: transactionRefNumber,
          tdsAmount: tdsAmount,
          bankAccountNumber: bankAccountNumber,
          typeOfTransactions: typeOfTransactions,
          vendorGstin: vendorGstin,
          invoiceNumber: invoiceNumber,
          invoiceDate: invoiceDateConvertingIntoString,
          paymentDate: PaymentDateConvertingIntostring,
          erpVendorCode: erpVendorCode,
        },
        edit_DrawerOpen: true,
        paymentDateDisplay: paymentDate,
        invoiceDateDisplay: invoiceDate,
      });
    };

    // Every cell renders as-is (or through the column's own `render`, e.g.
    // currency for Amount Paid), falling back to "-" when empty, so adding
    // or reordering a column in `filterableColumns` / `nonFilterableColumns`
    // is enough to update the header, filter row and body together.
    const renderCellValue = (col, tableData) => {
      const raw = tableData[col.key];
      if (raw === null || raw === undefined || raw === "") return "-";
      return col.render ? col.render(tableData) : raw;
    };

    if (
      this.state.allArcPaymentAdviceData &&
      this.state.allArcPaymentAdviceData.length >= 1
    ) {
      return this.state.allArcPaymentAdviceData.map((tableData, index) => {
        const {
          amountPaid,
          bankAccountNumber,
          createDate,
          created_date,
          erpVendorCode,
          invoiceNo,
          modifyDate,
          modified_date,
          orgCode,
          paymentDate,
          tdsAmount,
          transactionRefNumber,
          typeOfTransactions,
          vendorCode,
          vendorGstin,
          vendorName,
          vendorPan,
          voucherId,
          invoiceDate,
          adjustmentMethod,
        } = tableData; //destructuring
        return (
          <tr key={index}>
            {this.allColumns().map((col) => {
              const cellValue = renderCellValue(col, tableData);
              return (
                <td
                  key={col.key}
                  title={String(cellValue)}
                  style={{
                    width: col.width,
                    minWidth: col.width,
                    maxWidth: col.width,
                    borderRight: "1px solid #f1f5f9",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    padding: "6px 10px",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                >
                  {cellValue}
                </td>
              );
            })}
            <td
              style={{
                position: "sticky",
                right: 0,
                zIndex: 300,
                width: this.SHOW_COL_WIDTH,
                minWidth: this.SHOW_COL_WIDTH,
                maxWidth: this.SHOW_COL_WIDTH,
                background: "#fff",
                textAlign: "center",
                boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
                boxSizing: "border-box",
              }}
            >
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() =>
                  showToggleDrawer(
                    amountPaid,
                    bankAccountNumber,
                    createDate,
                    created_date,
                    erpVendorCode,
                    invoiceNo,
                    modifyDate,
                    modified_date,
                    orgCode,
                    paymentDate,
                    tdsAmount,
                    transactionRefNumber,
                    typeOfTransactions,
                    vendorCode,
                    vendorGstin,
                    vendorName,
                    vendorPan,
                    voucherId,
                    invoiceDate,
                    adjustmentMethod,
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else if (this.state.loading) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={this.allColumns().length + 1}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={this.allColumns().length + 1}>
            {this.state.appliedFilters.length > 0 ? (
              <>
                No records found for the selected filters.{" "}
                <span
                  role="button"
                  onClick={this.handleClearAllFilters}
                  style={{
                    color: this.HEADER_TEXT,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Clear filters
                </span>
              </>
            ) : (
              "No data found!"
            )}
          </td>
        </tr>
      );
    }
  }
  // ------------------------Payment advice table end-----------------------
  // ------------------------Payment advice add-----------------------------
  // add Payment Advice [add button] drawer open handeler---

  addPaymentAdvice_drawerOpen = () => {
    this.setState({ add_DrawerOpen: true });
  };

  // invoice date handler
  handleInvoiceDateChange = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      addPaymentAdviceData: {
        ...prevState.addPaymentAdviceData,
        invoiceDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(-2)}-${yy}`,
      },
      invoiceDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
        -2
      )}`,
    }));
  };

  // Payment date handler
  handlePaymentDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      this.setState((prevState) => ({
        addPaymentAdviceData: {
          ...prevState.addPaymentAdviceData,
          paymentDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
        },
        paymentDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      }));
    }
  };

  // add Payment Advice input field handler[number format]
  addPaymentAdvice_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      addPaymentAdviceData: {
        ...prevState.addPaymentAdviceData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // add Payment Advicey inputfield handler---
  addPaymentAdvice_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "paymentDate") {
      let changingDateOrder = event.target.value;
      let arrayDate = changingDateOrder.split("-").reverse().join("-");
      let arraytoString = toString(arrayDate);
      this.setState((prevState) => ({
        addPaymentAdviceData: {
          ...prevState.addPaymentAdviceData,
          [name]: arraytoString,
        },
      }));
    } else {
      this.setState((prevState) => ({
        addPaymentAdviceData: {
          ...prevState.addPaymentAdviceData,
          [name]: String(value),
        },
      }));
    }
  };

  // add Payment Advice add submit handler
  addPaymentAdvice_submitHandler = () => {

    axios
      .post(`/vendor/vendorpaymentadvice`, {
        entityGst: localStorage.getItem("gst"),
        record: this.state.addPaymentAdviceData,
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.vendorPaymentGetApi();
          this.setState({
            add_DrawerOpen: false,
            addPaymentAdviceData: {
              vendorGstin: "",
              invoiceNumber: "",
              invoiceDate: "",
              amountPaid: null,
              paymentDate: "",
              transactionRefNumber: "",
              tdsAmount: null,
              bankAccountNumber: "",
              typeOfTransactions: "",
              erpVendorCode: "",
            },
            invoiceDateDisplay: "",
            paymentDateDisplay: "",
          });
          toast.success("Vendor payment advice added successfully", {
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // add Payment Advice drawer close handler---
  addPaymentAdvice_DrawerClose = () => {
    this.setState({
      add_DrawerOpen: false,
      addPaymentAdviceData: {
        vendorGstin: "",
        invoiceNumber: "",
        invoiceDate: "",
        amountPaid: null,
        paymentDate: "",
        transactionRefNumber: "",
        tdsAmount: null,
        bankAccountNumber: "",
        typeOfTransactions: "",
        erpVendorCode: "",
      },
    });
  };

  // edit Payment Advice [edit button] drawer open handeler---

  editPaymentAdvice_drawerOpen = () => {
    this.setState({ edit_DrawerOpen: true });
  };
  editPaymentDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      editPaymentAdviceData: {
        ...prevState.editPaymentAdviceData,
        paymentDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(-2)}-${yy}`,
      },
      paymentDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
        -2
      )}`,
    }));
  };

  // edit Payment Advice input field handler[number format]
  editPaymentAdvice_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      editPaymentAdviceData: {
        ...prevState.editPaymentAdviceData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // edit Payment Advicey inputfield handler---
  editPaymentAdvice_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      editPaymentAdviceData: {
        ...prevState.editPaymentAdviceData,
        [name]: String(value),
      },
    }));
  };

  // edit Payment Advice edit submit handler
  editPaymentAdvice_submitHandler = () => {
    axios
      .post(`/vendor/vendorpaymentadvice`, {
        entityGst: localStorage.getItem("gst"),
        record: this.state.editPaymentAdviceData,
      })
      .then((res) => {
        if (res.data.status === false) {
          toast.error(res.data.message, { autoClose: 3000 });
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
          // toast.error(res.data.record.details[0].errors_in.invalid_data[0], {
          //   autoClose: 2000,
          // });
        } else {
          this.vendorPaymentGetApi();
          this.setState({
            edit_DrawerOpen: false,
          });
          toast.success("Vendor payment advice updated successfully", {
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        this.setState({
          edit_DrawerOpen: false,
        });
      });
  };

  // edit Payment Advice drawer close handler---
  editPaymentAdvice_DrawerClose = () => {
    this.setState({ edit_DrawerOpen: false, editPaymentAdviceData: {} });
  };

  // ------------------------Payment advice edit end-------------------------
  closeUploadData = () => {
    this.setState({ showUploadData: false });
    this.vendorPaymentGetApi(); // Table
  };

  showToggleDrawerClose = () => {
    this.setState({ showDrawer: false });
  };

  closeErpDrawer = () => {
    this.setState({
      erpConnectorModelOpen: false,
    });
  };

  // add payment modal
  addPaymentAdviceModalOpen = () => {
    this.setState({
      paymentAdviceModalOpen: true,
      paymentAdviceModalBackDrop: true,
    });
  };

  addPaymentAdviceModalClose = () => {
    this.getSellerInvoiceDataApi();
    this.setState({
      paymentAdviceModalOpen: false,
      paymentAdviceModalBackDrop: false,
      paymentAdviceModalSearchInput: "",
    });
  };

  // import effitrac / tally form section
  importEffitracTallyOpenDrawer = () => {
    this.setState({ openImportEffitracDrawer: true });
  };

  importFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        vendorPaymentFromDate: `${yy}-${(pad + mm).slice(-2)}-${(
          pad + dd
        ).slice(-2)}`,
      },
    }));
  };

  importToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        vendorPaymentToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importModifiedFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  fetchEffitacFormSubmitHandler = () => {
    this.setState({ effitracFormSubmitLoader: true });
    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        business_entity_id: localStorage.getItem("business_entity_id"),
      },
    }));
    const data = this.state.effitracFetchFromData;
    axios
      .post("/arc/effitrac/paymentreport", data)
      .then((res) => {
        this.setState({
          isEffitrac: true,
          effitracData: res.data.records.records,
          oldEffitracData: res.data.records.records,
          importEffitracFetchData: {},
          openImportEffitracDrawer: false,
          effitracFormSubmitLoader: false,
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          autoClose: 2000,
        });
        this.setState({ effitracFormSubmitLoader: false });
      });
  };

  closeEffitracTallyOpenDrawer = () => {
    this.setState({ openImportEffitracDrawer: false });
  };

  // import to cws button onclick--
  importToCWS = (dataForfun, uploadType = "Zoho",
    transId
  ) => {
    this.setState({ importToCwsLoading: true })
    let payLoadData = {}
    if (uploadType !== "Zoho") {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataForfun,
        upload_type: uploadType,
        api_point_name: "vendorpa",
        is_import: true,
        record_id: transId,
      }
    } else {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataForfun,
      }
    }
    axios
      .post("/arc/effitrac/vendorpayments", payLoadData)
      .then((res) => {
        this.refreshUploadHistoryTable();
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });

        // Edited by harsh Json formate changed Status Code: 204 NO CONTENT

        // res.data.record.details.map((row, index) => {
        //   if ("status" in row && row["status"] === "Fail") {
        //     row["record"]["InvoiceNo"] =
        //       "invoiceNo" in row["record"] ? row["record"]["invoiceNo"] : "";
        //     row["record"]["GSTIN"] =
        //       "gstin" in row["record"] ? row["record"]["gstin"] : "";
        //     return row;
        //   }
        //   return false;
        // });
        // var error_records = [];
        // let promises = res.data.record.details.map((v, i) => {
        //   if (v.status == "Fail") {
        //     error_records.push(v);
        //   }
        //   return true;
        // });
        // Promise.all(promises).then(() => {
        //   dis.setState({
        //     total_records: parseInt(res.data.record.summary.total_records),

        //     successful_records: parseInt(res.data.record.summary.valid_records),
        //     error_records: parseInt(res.data.record.summary.invalid_records),
        //     sellerCustomerData: error_records,
        //     error: null,
        //     showUploadData: true,
        //     loading: false,
        //   });
        // });
      })
      .catch((error) => {
        toast.error("Server Error Try After Some Time", {
          autoClose: 5000,
          progress: 0,
        });
      }).finally(() => {
        this.setState({ importToCwsLoading: false })
        this.closeErpDrawer()
      });
  };

  // back button after import effitrac data
 backHandler = () => {
  this.setState({ isEffitrac: false });
};

  //...............Edited By Harsh Handle Drawer.........
  handleZohoDrawer = () => {
    flagForVendorPayment = 1;
    this.setState({ openZohoDrawer: true });
  };

  closeZohoDrawer = () => {
    clearInterval(variableForTimer);
    this.setState({
      zohoDate: {},
      openZohoDrawer: false,
      // effitracImportFormloader: false,
      effitracFormSubmitLoader: false,
      buttonColor: "red",
      messageForConnection: "Establish Connection",
      grantToken: "",
    });
  };

  establishConnection = (e) => {
    e.preventDefault();
    window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${localStorage.getItem(
      "Client_ID"
    )}&state=testing&response_type=code&redirect_uri=${this.state.url
      }/zohoTesting&access_type=offline&prompt=Consent`;
  };

zohoDateChangeHandler = (item) => {
  const { name, value } = item;

  var d = new Date(value);
  var newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  let dateValue = newd.toISOString().replace("Z", "");

  this.setState((prevState) => ({
    zohoDate: {
      ...prevState.zohoDate,
      [name]: dateValue,
    },
  }));
};

  fetchingdataForZoho = () => {
    clearInterval(variableForTimer);
    flagForVendorPayment += 1;


    this.setState({ effitracFormSubmitLoader: true });
    axios
      .post("/arc/zoho_import", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        code: this.state.grantToken,
        type_of_data: "purchase_payment_advice",
        redirect_uri: `${this.state.url}/zohoTesting`,
        date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
      })
      .then((res) => {
        if (res.data.status === true) {
          this.setState({
            zohoDate: {},
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            effitracFormSubmitLoader: false,
            autoSync: false,
          });
        } else {
          this.setState({
            zohoDate: {},
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            effitracFormSubmitLoader: false,
            autoSync: false,
          });
          toast.error(res.data.message, {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        this.setState({
          zohoDate: {},
          buttonColor: "red",
          messageForConnection: "Establish Connection",
          grantToken: "",
          effitracFormSubmitLoader: false,
          autoSync: false,
        });
        toast.error(err?.response?.data?.message, {
          autoClose: 5000,
          progress: 0,
        });
      });

  };

  // upload history table show report fn
  // uploadReport = (id) => {
  //   axios
  //     .get(`/arc/get_data_upload_json/${id}`)
  //     .then((response) => {
  //       let res = response.data.records.records;
  //       if (response.data.records.type === "json") {
  //         var error_records = [];
  //         let promises = res.details.map((v, i) => {
  //           if (v.status === "Fail") {
  //             error_records.push(v);
  //           }
  //           return true;
  //         });

  //         Promise.all(promises).then(() => {
  //           this.setState({
  //             total_records: parseInt(res.summary.total_records),
  //             successful_records: parseInt(res.summary.valid_records),
  //             error_records: parseInt(res.summary.invalid_records),
  //             showUploadData: true,
  //             sellerCustomerData: error_records,
  //             error: null,
  //             loading: false,
  //             uploadStatusFail: response.data.records,
  //           });
  //           return true;
  //         });
  //       } else {
  //         this.setState({
  //           error: response.data.records.message,
  //           total_records: 0,
  //           loading: false,
  //           showUploadData: true,
  //         });
  //       }
  //     })
  //     .catch((error) => {});
  // };


  uploadReport = (id, pageParam = null) => {
    // Get ID from localStorage if not provided
    let currentId = id;
    if (!currentId) {
      currentId = localStorage.getItem('uploadReportId');
    }

    // If still no ID, show error
    if (!currentId) {
      console.error("uploadReport: Invalid ID", currentId);
      this.setState({ error: "Invalid ID", loading: false });
      return;
    }

    // Store ID in localStorage for future use
    localStorage.setItem('uploadReportId', currentId);

    const page = pageParam !== null ? pageParam : this.state.errorPage;
    const perErrorPages = this.state.perErrorPages || 10;

    if (page < 1 || !Number.isInteger(page)) {
      console.error("uploadReport: Invalid page number", page);
      this.setState({ error: "Invalid page number", loading: false });
      return;
    }

    if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
      console.error("uploadReport: Invalid rows per page", perErrorPages);
      this.setState({ error: "Invalid rows per page", loading: false });
      return;
    }

    console.log(`Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`);
    console.log(`API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`);

    this.setState({ loading: true, error: null });

    axios
      .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
      .then((response) => {
        console.log("API Response:", JSON.stringify(response.data, null, 2));
        const res = response.data.records;

        if (res.type === "json" && res.records && Array.isArray(res.records.details)) {
          const error_records = res.records.details.filter((v) => v.status === "Fail");
          this.setState({
            showUploadData: true,
            uploadStatusFail: res.records,
            total_records: parseInt(res.records.summary?.total_records) || 0,
            successful_records: parseInt(res.records.summary?.valid_records) || 0,
            error_records: parseInt(res.records.summary?.invalid_records) || 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: error_records,
            error: null,
            loading: false,
          });
        } else if (res.type === "message") {
          this.setState({
            showUploadData: true,
            uploadStatusFail: res,
            total_records: 0,
            successful_records: 0,
            error_records: 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: [],
            error: res.message,
            loading: false,
          });
        } else {
          console.warn("Invalid response format:", res);
          this.setState({
            error: "Invalid response format",
            total_records: 0,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        this.setState({
          loading: false,
          error: `Failed to fetch data: ${error.message}`,
        });
      });
  };

  errorLogExportHandlerForUpload = () => {
     // Get the currentId from localStorage
  let uploadId = localStorage.getItem('uploadReportId');
  this.setState({ loadingExport: true });

  let data = {
    business_entity_id: localStorage.getItem("business_entity_id"),
    upload_id: uploadId,
  };

  const contentType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const filename = `vendorPaymentAdviceUploadErrorLog.xlsx`;

  axios
    .post(`/uploads_errors_extract/download`, data)
    .then((res) => {
      this.downloadBase64File(contentType, res.data.file, filename);
      this.setState({ loadingExport: false });
    })
    .catch((error) => {
      console.error("Error downloading file:", error);
      this.setState({ loadingExport: false });
    });

  };

  handleErpConnectorButton = () => {
    this.setState({ erpConnectorModelOpen: true })
  }

  handleOpenAndCloseModel = () => {
    this.setState((prevState) => ({
      triggerModelFromToDate: !prevState.triggerModelFromToDate
    }));

  };

  inputHandlerFromDatePicker = (v) => {
    this.setState({ fromPeriodDisplay: v });
    this.setState({ fromPeriod: v })
  };

  inputHandlerToDatePicker = (v) => {
    this.setState({ toPeriodDisplay: v });
    this.setState({ toPeriod: v })
  };

  onSubmitHandlerForDateFilter = () => {

    this.export_to_excel(this.state.allArcPaymentAdviceData)

    this.setState({
      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: '',
      toPeriod: null
    })

  }

  renderDateFilter = () => {
    return (
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={this.state.triggerModelFromToDate}
        onHide={this.handleOpenAndCloseModel}
        dialogClassName="modal-50w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Export Payment Advice</Modal.Title>
        </Modal.Header>
        <ValidatorForm
          useRef="form"
          onSubmit={this.onSubmitHandlerForDateFilter}
          onError={(errors) => console.log(errors)}
        >
          <Modal.Body>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    name="dateFilterOption"
                    value={this.state.dateFilterOption}
                    onChange={(e) => this.setState({ dateFilterOption: e.target.value })}
                  >
                    <FormControlLabel
                      value="withDateFilter"
                      control={<Radio />}
                      label="With Date Filter"
                    />
                    <FormControlLabel
                      value="withoutDateFilter"
                      control={<Radio />}
                      label="Without Date Filter"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {this.state.dateFilterOption === "withDateFilter" && (
                <>
                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      From Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      maxDate={this.state.toPeriodDisplay ?? ""}
                      placeholder="From Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.fromPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerFromDatePicker(v)}
                    />
                  </Grid>

                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      To Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      minDateForDatepicker={this.state.fromPeriodDisplay ?? ""}
                      placeholder="To Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.toPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerToDatePicker(v)}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button className="button-primary" type="submit">
              Export
            </button>
            <button
              className="button-outlined-secondary"
              type="button"
              onClick={this.handleOpenAndCloseModel}
            >
              Cancel
            </button>
          </Modal.Footer>
        </ValidatorForm>
      </Modal>
    );
  };

  render() {
    // const { push, ...props } = this.props;
    return (
      <React.Fragment>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={() => this.props.history.push('/Data-Upload')}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
      </div>

        <ZohoModel
          openZohoDrawer={this.state.openZohoDrawer}
          buttonColor={this.state.buttonColor}
          establishConnection={this.establishConnection}
          messageForConnection={this.state.messageForConnection}
          timerForZohoInSalesCustomer={this.state.timer}
          closeZohoDrawer={this.closeZohoDrawer}
          zohoDateChangeHandler={this.zohoDateChangeHandler}
          effitracImportFormloader={this.state.effitracFormSubmitLoader}
          fetchingdataForZoho={this.fetchingdataForZoho}
          zohoDate={this.state.zohoDate}
          logApitName="purchase_payment_advice"
          nameOfTheModel="Vendor Payment Advice"
          importToCWS={this.importToCWS}
          exportToExcel={this.export_to_excel}
          zohoTableHeader={this.state.effitracHeader}
          zohoTableColumn={this.state.effitracCol}
          drawerKeys={[]}
          autoSync={this.state.autoSync} // Added autoSync prop
          setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
        />

        <ErpConnectorModel
          opeErpConnector={this.state.erpConnectorModelOpen}
          closeErpConnector={this.closeErpDrawer}
          logApitName="vendorpa"
          nameOfTheModel="Payment Data"
          importToCWS={this.importToCWS}
          exportToExcel={this.export_erp_data_to_excel}
          ErpTableHeader={this.state.effitracHeader}
          ErpTableColumn={this.state.effitracCol}
          connecotrName={this.state.erpConnectorName}
          erpDataExportLoading={this.state.erpDataExportLoading}
          importToCwsLoading={this.state.importToCwsLoading}
        />

        {/* <Drawer
          anchor="right"
          open={this.state.openZohoDrawer}
          onClose={this.closeZohoDrawer}
        >
          <div style={{ textAlign: "center", marignTop: "10px" }}>
            <button
              className="button-outlined-primary"
              disabled={this.state.buttonColor === "green" ? true : false}
              onClick={this.establishConnection}
            >
              {this.state.messageForConnection}
            </button>
          </div>
          {this.state.buttonColor === "green" && (
            <div
              style={{
                textAlign: "center",
                fontSize: "14px",
                marginTop: "10px",
              }}
            >
              <span style={{ color: this.state.timer < 30 ? "red" : "green" }}>
                Connection will be lost In{"  "}
                {this.state.timer} Seconds
              </span>
            </div>
          )}

          <ValidatorForm
            ref="form"
            onSubmit={this.fetchingdataForZoho}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ marginTop: "10px" }}>
              <label>
                Created From Date<span style={{ color: "red" }}>*</span>:
              </label>
              <ValidatedDatePicker
                fullWidth
                name="created_from_date"
                value={this.state.zohoDate.created_from_date ?? ""}
                onChange={(v) =>
                  this.zohoDateChangeHandler({
                    name: "created_from_date",
                    value: v,
                  })
                }
                requiredField="*"
                validators={["required"]}
                errorMessages={["This field is required"]}
              />
            </div>

            
              {this.state.effitracFormSubmitLoader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button
                  className="button-primary"
                  type="submit"
                  disabled={this.state.buttonColor === "red" ? true : false}
                >
                  Submit
                </button>
              )}
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeZohoDrawer}
              >
                cancel
              </Button>
            </ValidatorForm>
         
          </div>
        </Drawer> */}

        {/* --------import effitrac/tally payment advice section */}
        {/* import debit effitrac/tally */}
        <RightDrawer
          drawerName="Import Effitrac/Tally"
          open={this.state.openImportEffitracDrawer}
          onClose={this.closeEffitracTallyOpenDrawer}
        >
          <ValidatorForm
            ref="form"
            onSubmit={this.fetchEffitacFormSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ textAlign: "center" }}>
              Last Upload Date<br></br>
              {this.state.lastUploadDate} {this.state.lastUploadTime}
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>From Date:</label>
              <ValidatedDatePicker
                fullWidth
                name="fromDate"
                value={
                  this.state.effitracFetchFromData.vendorPaymentFromDate ?? ""
                }
                onChange={(v) => this.importFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>To Date:</label>
              <ValidatedDatePicker
                name="toDate"
                value={
                  this.state.effitracFetchFromData.vendorPaymentToDate ?? ""
                }
                onChange={(v) => this.importToDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified From Date:</label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={this.state.effitracFetchFromData.modifiedFromDate ?? ""}
                onChange={(v) => this.importModifiedFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified To Date:</label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.effitracFetchFromData.modifiedToDate ?? ""}
                onChange={(v) => this.importModifiedToDateChangeHandler(v)}
              />
            </div>

            {/* submit and back button */}

            <div className="mt-20">
              {this.state.effitracFormSubmitLoader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeEffitracTallyOpenDrawer}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>

        {/* -----------------Vendor add payment Model --------------------  */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.paymentAdviceModalOpen}
          onHide={this.addPaymentAdviceModalClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Bill</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={classes.searchField}>
              <Grid container spacing={3}>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={this.onSubmitHandler}
                    onError={(errors) => console.log(errors)}
                  >
                    <InputField
                      // textLabel="Search"
                      inputPlacholder="Search...."
                      inputType="text"
                      requiredField=" "
                      name="Search_by_customer_name"
                      value={this.state.paymentAdviceModalSearchInput ?? ""}
                      textOnchangeFunction={this.arcPaymentAdviceModalSearch}
                    />
                  </ValidatorForm>
                </Grid>
              </Grid>
            </div>
            <div className={classes.modalTableResponisve}>
              <table className={classes.tableCss}>
                <tbody>
                  <tr>{this.paymentAdviceModal_TableHeader()}</tr>
                  {this.paymentAdviceModal_tableBody()}
                </tbody>
              </table>
            </div>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.rowCountAddPayment} //total row count
              rowsPerPage={this.state.rowsPerPageAddPayment}
              page={this.state.pageAddPayment}
              onPageChange={this.handleChangePageForPaymentAdvice}
              onRowsPerPageChange={this.handleChangeRowsPerPageForPaymentAdvice}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="small"
              variant="outlined"
              onClick={this.addPaymentAdviceModalClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* upload temp Button */}
        {(localStorage.getItem('is_uploads') !== "N") && <>
          {/* <div>
            <ToggleSwitch
              onChange={() =>
                this.setState({
                  showUploadHistroyTable: !this.state.showUploadHistroyTable,
                })
              }
              value={this.state.showUploadHistroyTable}
              label="Upload Payment Advice"
            />
          </div> */}

          {/* File upload history table  */}
          {(localStorage.getItem('is_uploads') !== "N") && (
            <div>
              <BoxWrapper
                boxTitle="Upload Payment Advice History"
                zohoEffitracEnable={
                  localStorage.getItem("Client_ID") &&
                  !this.state.isEffitrac &&
                  canWrite("UPLOADING PURCHASE") && 
                  true
                }
                zohoEffitracFn={this.handleZohoDrawer}
                // enableImportToEffTallybutton={localStorage.getItem("Trigger_Effitrac/Tally_Button") && localStorage.getItem("Trigger_Effitrac/Tally_Button") === "true" && !this.state.isEffitrac }
                // importToEffiTallyFn={this.importEffitracTallyOpenDrawer}
                enableAddButton={this.state.erpConnectorName && canWrite("UPLOADING PURCHASE")  ? true : false}
                addButtonLabel={this.state.erpConnectorName}
                addButtonHandlerFn={this.handleErpConnectorButton}
              >
                <this.CollectionListActions />
                <div className="responsive-table">
                  <table className="custome-table">
                    <thead>
                      <tr>
                        <th>Last Upload Date & Time</th>
                        <th>Status</th>
                        <th>Upload Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.uploadHistoryTableData.map((item, i) => {
                        return (
                          <tr>
                            <td>{item.upload_date}</td>
                            <td>{item.status}</td>
                            <td>{item.upload_type}</td>
                            <td>
                              {item.status === "In Progress" ? (
                                <RemoveRedEyeOutlinedIcon color="disabled" />
                              ) : item.status === "Uploaded" ? (
                                <RemoveRedEyeOutlinedIcon color="disabled" />
                              ) : (
                                <RemoveRedEyeOutlinedIcon
                                  className="action-icon-button showIcon"
                                  onClick={() => this.uploadReport(item.id)}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      {this.state.uploadHistoryTableData.length === 0 && (
                        <tr>
                          <td
                            colspan={4}
                            style={{ color: "red", textAlign: "center" }}
                          >
                            No Data Found!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </BoxWrapper>
            </div>
          )}
        </>}

        {this.state.showUploadData ? (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className={classes.Main_frame}>
                  <div className={classes.form_title_bar}>
                    <div class="form_title_name">
                      <ul
                        style={{
                          listStyle: "none",
                          marginBottom: "0px",
                          padding: "0px",
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <li style={{ fontWeight: "700" }}>Upload Details</li>
                        <li>
                          {this.state.error_records > 0 && (
                            // <button
                            //   className="button-outlined-primary"
                            //   onClick={this.errorLogExportHandlerForUpload}
                            // >
                            //   Export
                            // </button>
                            <button
                                className="button-outlined-primary"
                                onClick={this.errorLogExportHandlerForUpload}
                                disabled={this.state.loadingExport} // Disable button during loading
                              >
                                {this.state.loadingExport ? (
                                  <span>Loading...</span> // Simple text loader
                                ) : (
                                  <span>Export</span>
                                )}
                              </button>

                          )}

                          <button
                            className="close-icon-button"
                            onClick={this.closeUploadData}
                          >
                            <ClearIcon style={{ color: "var(--app-bar-bg)" }} />
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className={classes.form_body_part}>
                    {this.state.total_records > 0 && (
                      <div>
                        {/* card component */}
                        <div
                          style={{ marginLeft: "30px", marginRight: "30px" }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#6f9eaf"
                                cardTitle="Total Records"
                                cardBody={this.state.total_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#007965"
                                cardTitle="Successful Records"
                                cardBody={this.state.successful_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#eb596e"
                                cardTitle="Error Records"
                                cardBody={this.state.error_records}
                              />
                            </Grid>
                          </Grid>
                        </div>
                        {/* datatable component */}
                        <div
                          style={{
                            height: "300",
                            margin: "20px 30px 0px 30px",
                          }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <div>
                                <MuiThemeProvider>
                                  {/* <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    showRowHover={true}
                                    page={1}
                                    count={this.state.total_records}
                                    // showCheckboxes={true}
                                  /> */}
                                  <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    page={this.state.errorPage}
                                    count={this.state.errortotal}
                                    rowSize={this.state.perErrorPages}
                                    showRowSizeControls={true}
                                    showFooterToolbar={true}
                                    onNextPageClick={this.handleNextPage}
                                    onPreviousPageClick={this.handlePreviousPage}
                                    onRowSizeChange={this.handleRowsPerPageChange}
                                  />
                                </MuiThemeProvider>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    )}
                    {this.state.error && (
                      <div style={{ color: "red" }}>
                        <ErrorIcon />
                        {this.state.error}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}

        {/* table  */}

        <BoxWrapper
          boxTitle="Payment Advice Details" // export to excel
          exportToExcelEnable={true}
          exportToExcelFn={this.handleOpenAndCloseModel}
          exportToExcelEnable1={true}
          exportButtonLabel1={this.state.appliedFilters.length > 0 && this.state.activeFilters ? "Export Filtered" : "Export All"}
          exportToExcelFn1={this.exportall_to_excel}
          loadingexcel1={this.state.isExportingAll}
          // back button
          backButtonForZohoEnable={this.state.isEffitrac}
          backButton={this.backHandler}
          // import to cws button
          importToCwsEnableForZoho={this.state.isEffitrac}
          importToCwsForZoho={this.importToCWS}
          // search input
          // enableSearchInput={true}
          // searchInputPlaceholder="Search..."
          // searchInputOnchange={
          //   this.state.isEffitrac
          //     ? this.handleSearchInputChangeForZohoAndEffitrack
          //     : this.handleSearchInputChange
          // }
          // Filter button inside the BoxWrapper header (see
          // FILTER_BUTTON_IN_BOXWRAPPER at the top of this file)
          headerExtra={
            FILTER_BUTTON_IN_BOXWRAPPER && !this.state.isEffitrac
              ? this.renderFilterButton()
              : null
          }
        >
          {this.state.isEffitrac ? (
            <CustomTable
              headers={this.state.effitracHeader}
              columns={this.state.effitracCol}
              data={this.state.effitracData}
              actions={this.state.actions}
            />
          ) : (
            <>
              {/* Filter button here only until it is moved into BoxWrapper */}
              {!FILTER_BUTTON_IN_BOXWRAPPER && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "8px",
                  }}
                >
                  {this.renderFilterButton()}
                </div>
              )}

              {this.renderAppliedFilterChips()}

              {/* Table on the left, filter panel (when open) on the right —
                  the panel stretches to the table's height. */}
              <div style={{ display: "flex", alignItems: "stretch", gap: "12px" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {/*
                    overflowX: "auto" turns the wide, fixed-width grouped table
                    below into a horizontally-scrolling region instead of
                    letting the browser squeeze the columns to fit. The table's
                    own minWidth is the sum of every column's fixed width plus
                    the sticky SHOW column.
                  */}
                  <div
                    className="responsive-table"
                    style={{ overflowX: "auto", overflowY: "visible", maxWidth: "100%" }}
                  >
                    <table
                      className="custome-table"
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        minWidth: this.getTableMinWidth(),
                        tableLayout: "fixed",
                        width: "100%",
                      }}
                    >
                      {/* colgroup pins every column to its real width. */}
                      <colgroup>
                        {this.allColumns().map((col) => (
                          <col key={col.key} style={{ width: col.width, minWidth: col.width }} />
                        ))}
                        <col style={{ width: this.SHOW_COL_WIDTH, minWidth: this.SHOW_COL_WIDTH }} />
                      </colgroup>
                      <tbody>
                        {/* Grouped header: returns [groupRow, labelRow] — each
                            is already a <tr>, so no extra <tr> wrapper here. */}
                        {this.arc_paymentAdvice_TableHeader()}
                        {this.arc_PaymentAdvice__data()}
                      </tbody>
                    </table>
                  </div>
                  <TablePagination
                    rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                    component="div"
                    count={this.state.rowCount} //total row count
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </div>

                {this.renderFilterPanel()}
              </div>
            </>
          )}
        </BoxWrapper>

        {/* show data */}
        <RightDrawer
          drawerName="Payment Advice Details"
          open={this.state.showDrawer}
          onClose={this.showToggleDrawerClose}
        >
          {Object.keys(this.state.showPaymentDetailsData).length && (
            <>
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="VENDOR PAN"
                value={this.state.showPaymentDetailsData.showvendorPan}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Voucher ID"
                value={this.state.showPaymentDetailsData.showvoucherId}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Transaction Reference Number"
                value={this.state.showPaymentDetailsData.showTransactionRefNo}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Transaction Type"
                value={this.state.showPaymentDetailsData.showTransactionType}
              />


              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Payment Date"
                value={this.state.showPaymentDetailsData.showPaymentDate}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Amount Paid"
                value={this.indianRupeesFormat(
                  this.state.showPaymentDetailsData.showAmountPaid
                )}
              />
              {/* <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="TDS Amount"
                value={this.indianRupeesFormat(
                  this.state.showPaymentDetailsData.showTdsAmount
                )}
              /> */}
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Bill Date"
                value={this.state.showPaymentDetailsData.showInvoiceDate}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Method of Adjustment"
                value={this.state.showPaymentDetailsData.showadjustmentMethod}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Modify Date"
                value={this.state.showPaymentDetailsData.modified_date}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Create Date"
                value={this.state.showPaymentDetailsData.created_date}
              />
            </>
          )}
          <button
            className="button-outlined-secondary mt-20"
            onClick={this.showToggleDrawerClose}
          >
            close
          </button>
        </RightDrawer>
        {/* table end */}

        {/* add payment */}
        <Drawer
          anchor="right"
          open={this.state.add_DrawerOpen}
          variant={
            this.state.paymentAdviceModalBackDrop === true ? "persistent" : ""
          }
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.addPaymentAdvice_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              {/* modal open button */}
              <Button
                style={{ marginTop: "45px" }}
                size="small"
                fullWidth
                variant="outlined"
                onClick={this.addPaymentAdviceModalOpen}
              >
                select bill*
              </Button>
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="vendorGstin"
                value={this.state.addPaymentAdviceData.vendorGstin ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />
              <InputField
                inputType="text"
                textLabel="Vendor Code+"
                name="erpVendorCode"
                value={this.state.addPaymentAdviceData.erpVendorCode ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />
              <InputField
                inputType="text"
                textLabel="Invoice Number"
                name="invoiceNumber"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addPaymentAdviceData.invoiceNumber ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Date"
                name="invoiceDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.invicedateForAddDisplay ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  ₹ Amount Paid<span style={{ color: "red" }}>*</span>:
                </label>{" "}
                <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.addPaymentAdviceData.amountPaid
                      ? this.state.addPaymentAdviceData.amountPaid
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  required
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addPaymentAdviceData: {
                        ...prevState.addPaymentAdviceData,
                        amountPaid: parseFloat(value),
                      },
                    }));
                  }}
                />{" "}
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ TDS Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.addPaymentAdviceData.tdsAmount
                      ? this.state.addPaymentAdviceData.tdsAmount
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addPaymentAdviceData: {
                        ...prevState.addPaymentAdviceData,
                        tdsAmount: parseFloat(value),
                      },
                    }));
                  }}
                />{" "}
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>
                  Payment Date<span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="paymentDate"
                  value={this.state.addPaymentAdviceData.paymentDate ?? ""}
                  onChange={(e) => this.handlePaymentDateChange(e)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>
              <InputField
                inputType="text"
                textLabel="Transaction Reference Number"
                name="transactionRefNumber"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={
                  this.state.addPaymentAdviceData.transactionRefNumber ?? ""
                }
                // inputProps={{
                //   readOnly: true,
                // }}
                textOnchangeFunction={this.addPaymentAdvice_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Bank Account Number"
                name="bankAccountNumber"
                // requiredField="*"
                // validator={["required"]}
                // errorMsg={["This field is required"]}
                value={this.state.addPaymentAdviceData.bankAccountNumber ?? ""}
                textOnchangeFunction={this.addPaymentAdvice_inputHandler}
              />
              <SelectField
                SelectLabel="Transaction Type"
                choice_id="id"
                choice_name="typeOfTransactionss"
                name="typeOfTransactions"
                // requiredField="*"
                // validator={["required"]}
                // errorMsg={["This field is required"]}
                value={this.state.addPaymentAdviceData.typeOfTransactions ?? ""}
                choices={[
                  { id: "Bank", typeOfTransactionss: "Bank" },
                  { id: "Cash", typeOfTransactionss: "Cash" },
                ]}
                textOnchangeFunction={this.addPaymentAdvice_inputHandler}
              />

              {/* modal open button */}
              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.addPaymentAdvice_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
            {/* Drawer body end */}
          </div>
        </Drawer>

        {/* add payment end */}

        {/*.................................Edit Payment ...........................*/}

        <Drawer
          anchor="right"
          open={this.state.edit_DrawerOpen}
          onClose={this.editPaymentAdvice_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            <ValidatorForm
              ref="form"
              onSubmit={this.editPaymentAdvice_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              <div style={{ marginTop: "20px" }}>
                <label>
                  ₹ Amount Paid<span style={{ color: "red" }}>*</span>:
                </label>{" "}
                <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  value={
                    this.state.editPaymentAdviceData.amountPaid
                      ? this.state.editPaymentAdviceData.amountPaid
                      : ""
                  }
                  prefix="₹"
                  required
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editPaymentAdviceData: {
                        ...prevState.editPaymentAdviceData,
                        amountPaid: parseFloat(value),
                      },
                    }));
                  }}
                />{" "}
              </div>
              <InputField
                inputType="text"
                textLabel="Transaction Reference Number"
                name="transactionRefNumber"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={
                  this.state.editPaymentAdviceData.transactionRefNumber ?? ""
                }
                textOnchangeFunction={this.editPaymentAdvice_inputHandler}
              />
              <div style={{ marginTop: "20px" }}>
                <label>
                  ₹ TDS Amount<span style={{ color: "red" }}>*</span>:
                </label>{" "}
                <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  value={
                    this.state.editPaymentAdviceData.tdsAmount
                      ? this.state.editPaymentAdviceData.tdsAmount
                      : ""
                  }
                  prefix="₹"
                  required
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editPaymentAdviceData: {
                        ...prevState.editPaymentAdviceData,
                        tdsAmount: parseFloat(value),
                      },
                    }));
                  }}
                />{" "}
              </div>

              <InputField
                inputType="text"
                textLabel="Bank Account Number"
                name="bankAccountNumber"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editPaymentAdviceData.bankAccountNumber ?? ""}
                textOnchangeFunction={this.editPaymentAdvice_inputHandler}
              />
              <SelectField
                SelectLabel="Transaction Type"
                choice_id="id"
                choice_name="typeOfTransactions"
                name="typeOfTransactions"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={
                  this.state.editPaymentAdviceData.typeOfTransactions ?? ""
                }
                choices={[
                  { id: "Bank", typeOfTransactions: "Bank" },
                  { id: "Cash", typeOfTransactions: "Cash" },
                ]}
                textOnchangeFunction={this.editPaymentAdvice_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Invoice Date"
                name="invoiceDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.invoiceDateDisplay ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />
              <InputField
                inputType="text"
                textLabel="payment Date"
                name="paymentDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.paymentDateDisplay ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.editPaymentAdvice_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
            {/* Drawer body end */}
          </div>
        </Drawer>

        {/* edit payment end */}
        {this.renderDateFilter()}
      </React.Fragment>
    );
  }
}

export default withRouter(VendorpaymentAdvice);